import React, {useEffect, useRef, useState} from "react";
import bgImage from "../../../assets/images/bg-sign-up-cover.jpeg";
import CoverLayout from "../components/CoverLayout";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";

import {
    Button, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl, FormControlLabel,
    FormHelperText,
    InputAdornment, Radio, RadioGroup,
    Popover, Tooltip, ClickAwayListener
} from "@mui/material";
import MDInput from "../../../components/MDInput";
import IconButton from "@mui/material/IconButton";
import {Visibility, VisibilityOff, Help, FormatListBulleted, Search, Info } from "@mui/icons-material";
import MDButton from "../../../components/MDButton";
import {useDispatch, useSelector} from "react-redux";
import YupPassword from 'yup-password';
import {
    forgetPassword, forgetPasswordByUser,
    getEmailCodeForForgetPW, getVerificationCode, getEmailCodeVerify,
    onErrorAlert,
    onSuccessAlert
} from "../../../actions";
import {noop} from "lodash";
import {Link} from "react-router-dom";
import FramerFade from "../../../components/Animation/Fade";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {styled} from "@mui/material/styles";
import {useTranslation} from "react-i18next";

YupPassword(yup);
export default function ForgetPasswordDialog({openModal, setOpenModal}) {

    const style = {
        img: {
            width: '120px',
            height: '40px',
            position: 'absolute',
            right: 0,
            top: -10,
            border: '2px solid grey',
            cursor: 'pointer'
        }
    }
    const [img, setImg] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
    const darkMode = useSelector(state => state?.common?.darkMode)
    const verification = useSelector(state => state?.auth?.verification)
    const dispatch = useDispatch()
    const [uuid, setUuid] = useState('');
    const [activeStep, setActiveStep] = useState(0)
    const [emailMode, setEmailMode] = useState(true)
    const [code, setCode] = useState(Array(6).fill(''));
    const [seconds, setSeconds] = useState(0);
    const [show, setShow] = useState(false);
    const intervalRef = useRef();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isOpenHelp, setIsOpenHelp] = React.useState(false);
    const [isOpenInfo, setIsOpenInfo] = React.useState(false);
    const { t, i18n } = useTranslation();

    const schema = yup
        .object({
            mode: yup.boolean(),
            email: yup.string().email().required(t('ForgotPasswordPage.Email is Required')),
            password: yup.string().min(
                6,
                t('ForgotPasswordPage.Password must contain 6 or more characters')
            ).minLowercase(1, t('ForgotPasswordPage.Password must contain at least 1 lower case letter'))
                .minUppercase(1, t('ForgotPasswordPage.Password must contain at least 1 upper case letter'))
                .minNumbers(1, t('ForgotPasswordPage.Password must contain at least 1 number'))
                .required(t("Required")),
            confirmpassword: yup
                .string()
                .oneOf([yup.ref("password"), null], t('ForgotPasswordPage.Passwords must match'))
                .required(t("Required")),
        })

    const schema2 = yup
        .object({
            owner: yup.string().min(4, t('ForgotPasswordPage.Owner ID must contain 4 or more characters')).required(t("Required")),
            user: yup.string().min(3, t('ForgotPasswordPage.User ID must contain 3 or more characters')).required(t("Required")),
            userpassword: yup.string().min(
                6,
                t('ForgotPasswordPage.Password must contain 6 or more characters')
            ).minLowercase(1, t('ForgotPasswordPage.Password must contain at least 1 lower case letter'))
                .minUppercase(1, t('ForgotPasswordPage.Password must contain at least 1 upper case letter'))
                .minNumbers(1, t('ForgotPasswordPage.Password must contain at least 1 number'))
                .required(t("Required")),
            userconfirmpassword: yup
                .string()
                .oneOf([yup.ref("userpassword"), null], t('ForgotPasswordPage.Passwords must match'))
                .required(t("Required")),
        })

    const {
        register,
        setError,
        trigger,
        reset,
        handleSubmit,
        getValues,
        setValue,
        clearErrors,
        formState: {errors}
    } = useForm({
        resolver: emailMode ? yupResolver(schema) : yupResolver(schema2),
        mode: "onChange"
    });

    useEffect(() => {
        setActiveStep(0)
        setEmailMode(true)
    }, []);


    const handleClose = () => {
        setOpenModal(false)
        clearErrors()
        reset()
        setShowPassword(false)
        setShowPasswordConfirmation(false)

    }


    useEffect(() => {
        const intervalId = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
        }, 1000);
        if (seconds === 0) {
            setShow(false);
        } else {
            setShow(true)
        }

        return () => clearInterval(intervalId);
    }, [seconds]);

    useEffect(() => {
        if (!emailMode) {
            setValue('mode', false)
            setActiveStep(3)
        }
    }, [emailMode]);

    useEffect(() => {
        if (openModal) {
            setActiveStep(0)
            setCode(Array(6).fill(''));
            setValue('password', '')
            setValue('confirmpassword', '')
        }
    }, [openModal]);

    useEffect(() => {
        if (verification) {
            setImg(`data:image/gif;base64,${verification?.img}`)
            setUuid(verification.uuid)
        }
    }, [verification]);


    const handleChange = (e, index) => {
        const value = e.target.value;
        if (value.length <= 1) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (value && index < 5) {
                document.getElementById(`code-${index + 1}`).focus();
            }
        }
    };
    
    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData('text').slice(0, 6);
        const newCode = pasteData.split('');
        while (newCode.length < 6) {
            newCode.push('');
        }
        setCode(newCode);
        
        const lastFilledIndex = newCode.findIndex((char, i) => char === '' || i === newCode.length - 1);
        document.getElementById(`code-${lastFilledIndex}`).focus();
    };
    
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !code[index]) {
            document.getElementById(`code-${index - 1}`).focus();
        } else if (e.key === "Enter") {
            submitCode();
        }
    };
    
    const onEmailResendSuccess = () => {
        dispatch(onSuccessAlert(t('ForgotPasswordPage.Resend verification code successfully')))
        setSeconds(99);
    }

    const handleResendVerifyEmail = async () => {
        if (!errors.email && getValues('email') !== '') {
            const email = getValues('email')
            await dispatch(getEmailCodeForForgetPW(email, onEmailResendSuccess, onError))
        }
    }

    const onForgetPasswordSuccess = (data) => {
        dispatch(onSuccessAlert(t('ForgotPasswordPage.Reset password successfully')))
        setActiveStep(0)
        setEmailMode(true)
        handleClose()
    }

    const onSubmit = async (data) => {
        const verificationCode = code.join('');
        if (emailMode) {
            if (verificationCode !== '') {
                let formData = {}
                formData.emailAddress = data.email
                formData.newPassword = data.password
                formData.confirmPassword = data.confirmpassword
                formData.verifyCode = verificationCode

                await dispatch(forgetPassword(formData, onForgetPasswordSuccess, onError))

            } else {
                return null
            }
        } else {
            let formData = {}

            formData.ownerId = data.owner
            formData.userName = data.user
            formData.newPassword = data.userpassword
            formData.confirmPassword = data.userconfirmpassword
            formData.code = Number(data.code)
            formData.uuid = uuid

            await dispatch(forgetPasswordByUser(formData, onForgetPasswordSuccess, onError))

        }


    }
    const onError = (msg) => {
        dispatch(onErrorAlert(msg))
    }
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleClickShowPasswordConfirmation = () => setShowPasswordConfirmation((show) => !show);

    const handleNext = () => {
        const verificationCode = code.join('');
        if (activeStep === 0) {
            handleVerifyEmail().then()
        }
        if (activeStep === 1) {
            if (verificationCode !== '') {
                submitCode();
            } else {
                dispatch(onErrorAlert(t('ForgotPasswordPage.Please fill the 6-digits verification code')))
            }

        }

    }
    const onEmailSuccess = () => {
        setShow(true)
        setSeconds(99)
        setActiveStep(1)
    }
    
    const onEmailCodeSuccess = () => {
        setActiveStep(2)
    }
    
    const handleVerifyEmail = async () => {
        if(!errors.email && getValues('email') !== ''){
            const email = getValues('email')
            await dispatch(getEmailCodeForForgetPW(email, onEmailSuccess, onError))
        } else {
            await trigger("email")
        }
    }
    
    const submitCode = async () => {
        const formData = {};
        const verificationCode = code.join('');
        if(verificationCode!==''){
            formData.emailAddress = getValues('email')
            formData.emailCode = verificationCode
            await dispatch(getEmailCodeVerify(formData, onEmailCodeSuccess, onError))
        }
    };
    
    const handleClickShowHelp = (event) => {
        setAnchorEl(event.currentTarget);
        setIsOpenHelp(!isOpenHelp);
    }


    return (
        <React.Fragment>
            <Dialog
                open={openModal}
                onClose={handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth={false}
                maxWidth='200px'

            >
                <DialogTitle id="scroll-dialog-title">{`${t('ForgotPasswordPage.Forgot Password')}?`}</DialogTitle>
                <DialogContent
                >
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}
                        sx={{overflow:'hidden'}}
                    >
                        <MDBox pt={2} pb={2} px={3} sx={{width: '320px'}} >
                            <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                                {activeStep === 0 && <FramerFade isActive={activeStep === 0} delay={0}>
                                    <Grid textAlign='center' mb={2}>
                                        <Icon style={darkMode ? {color: 'white'} : {color: 'text'}}
                                              fontSize={'large'}>email</Icon>
                                    </Grid>
                                    <MDTypography sx={{fontWeight: 'medium'}} align='center' variant={'button'}>
                                        {t('ForgotPasswordPage.Please Enter Your Email Address')}
                                    </MDTypography>
                                    <MDBox mt={2} mb={1}>
                                        <FormControl
                                            error={!!errors.email}
                                            fullWidth
                                            required
                                            focused={true}
                                        >
                                            <MDInput
                                                type="email"
                                                label= {t('ForgotPasswordPage.Email')}
                                                fullWidth
                                                variant={'standard'}
                                                required
                                                {...register("email")}
                                            />
                                            <FormHelperText
                                                sx={{fontWeight: 'medium'}}>{errors?.email?.message}</FormHelperText>
                                        </FormControl>

                                    </MDBox>
                                    <MDBox mt={2}>
                                        <MDTypography
                                            variant="button"
                                            fontWeight="bold"
                                            color="info"
                                            textGradient
                                            sx={{cursor: 'pointer'}}
                                            onClick={() => {
                                                setEmailMode(false)
                                            }}
                                        >
                                            {t('ForgotPasswordPage.try another way')}
                                        </MDTypography>
                                    </MDBox>
                                </FramerFade>}
                                <FramerFade isActive={activeStep === 1} delay={0}>
                                    <Grid textAlign='center'><Icon style={darkMode ? {color: 'white'} : {color: 'text'}}
                                                                   fontSize={'large'}>lock</Icon></Grid>
                                    <Typography variant={'h5'} align="center">{t('ForgotPasswordPage.Enter your verification Code')}</Typography>
                                    <MDTypography align="center" display="block" variant="button" my={1}>
                                        {`${t('ForgotPasswordPage.We sent a verification code to')} ${getValues('email')}`}
                                    </MDTypography>
                                    <MDBox component="form" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                        <MDBox sx={{ display: 'flex', gap: 1 }} onPaste={handlePaste}>
                                            {code.map((digit, index) => (
                                                <TextField
                                                    key={index}
                                                    id={`code-${index}`}
                                                    value={digit}
                                                    onChange={(e) => handleChange(e, index)}
                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                    InputProps={{ maxLength: 1, style: { textAlign: 'center' } }}
                                                    autoFocus={index === 0}
                                                    sx={{
                                                        width: '40px', height: '20px', '& .MuiOutlinedInput-input': {
                                                            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                                '-webkit-appearance': 'none',
                                                            }
                                                        }
                                                    }}
                                                />
                                            ))}
                                        </MDBox>
                                    </MDBox>
                                    <MDBox mt={4} display="flex" alignItems="center" justifyContent="start">
                                        <MDTypography display="block" variant="button">
                                            {t('ForgotPasswordPage.Haven\'t receive a code?')}
                                        </MDTypography>
                                        <Button sx={{padding: 1}} onClick={handleResendVerifyEmail}
                                                disabled={show}>{t('Resend')}</Button>
                                        <MDTypography display="block" variant="button">
                                            {show && `${seconds}s`}
                                        </MDTypography>
                                    </MDBox>

                                    {/*<MDBox mb={2}>*/}
                                    {/*  <MDInput type="password" label="Password" variant="standard" fullWidth />*/}
                                    {/*</MDBox>*/}
                                    {/*<MDBox display="flex" alignItems="center" ml={-1}>*/}
                                    {/*  <Checkbox />*/}
                                    {/*  <MDTypography*/}
                                    {/*      variant="button"*/}
                                    {/*      fontWeight="regular"*/}
                                    {/*      color="text"*/}
                                    {/*      sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}*/}
                                    {/*  >*/}
                                    {/*    &nbsp;&nbsp;I agree the&nbsp;*/}
                                    {/*  </MDTypography>*/}
                                    {/*  <MDTypography*/}
                                    {/*      component="a"*/}
                                    {/*      href="#"*/}
                                    {/*      variant="button"*/}
                                    {/*      fontWeight="bold"*/}
                                    {/*      color="info"*/}
                                    {/*      textGradient*/}
                                    {/*  >*/}
                                    {/*    Terms and Conditions*/}
                                    {/*  </MDTypography>*/}
                                    {/*</MDBox>*/}
                                    <MDBox mt={2}>
                                        <MDTypography
                                            variant="button"
                                            fontWeight="bold"
                                            color="info"
                                            textGradient
                                            sx={{cursor: 'pointer'}}
                                            onClick={() => {
                                                setEmailMode(false)
                                            }}
                                        >
                                            {t('ForgotPasswordPage.try another way')}
                                        </MDTypography>
                                    </MDBox>
                                </FramerFade>
                                <FramerFade isActive={activeStep === 2} delay={0}>
                                    <Grid textAlign='center'><Icon style={darkMode ? {color: 'white'} : {color: 'text'}}
                                                                   fontSize={'large'}>vpn_key</Icon></Grid>
                                    <Typography variant={'h5'} align="center">{t('ForgotPasswordPage.Enter New Password')}</Typography>
                                    <MDBox mb={1} mt={2}>
                                        <FormControl
                                            error={!!errors.password}
                                            fullWidth
                                            required
                                            focused={true}
                                        >
                                            <MDInput
                                                type={showPassword ? 'text' : 'password'}
                                                label={t('ForgotPasswordPage.New Password')}
                                                variant="standard"
                                                fullWidth
                                                required
                                                {...register("password")}
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={handleClickShowPassword}
                                                                edge="end"
                                                            >
                                                                {showPassword ? <VisibilityOff
                                                                        color={darkMode ? 'white' : 'info.main'}/> :
                                                                    <Visibility
                                                                        color={darkMode ? 'white' : 'info.main'}/>}
                                                            </IconButton>
                                                        </InputAdornment>

                                                }}
                                            />
                                            <FormHelperText
                                                sx={{fontWeight: 'medium'}}>{errors?.password?.message}</FormHelperText>
                                            <MDTypography variant={'caption'} mt={1}>
                                                {t('ForgotPasswordPage.At least 6 characters')}
                                            </MDTypography>
                                            <MDTypography variant={'caption'}>{t('ForgotPasswordPage.Have at least one uppercase')}</MDTypography>
                                            <MDTypography variant={'caption'}>{t('ForgotPasswordPage.Have at least one lowercase')}</MDTypography>
                                            <MDTypography variant={'caption'}>{t('ForgotPasswordPage.Have at least one number')}</MDTypography>
                                        </FormControl>
                                    </MDBox>
                                    <MDBox mb={2}>
                                        <FormControl
                                            error={!!errors.confirmpassword}
                                            fullWidth
                                            required
                                            focused={true}
                                        >
                                            <MDInput
                                                type={showPasswordConfirmation ? 'text' : 'password'}
                                                label= {t('ForgotPasswordPage.New Password Confirmation')}
                                                variant="standard"
                                                fullWidth
                                                required
                                                {...register("confirmpassword")}
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={handleClickShowPasswordConfirmation}
                                                                edge="end"
                                                            >
                                                                {showPasswordConfirmation ? <VisibilityOff
                                                                        color={darkMode ? 'white' : 'info.main'}/> :
                                                                    <Visibility
                                                                        color={darkMode ? 'white' : 'info.main'}/>}
                                                            </IconButton>
                                                        </InputAdornment>

                                                }}
                                            />
                                            <FormHelperText
                                                sx={{fontWeight: 'medium'}}>{errors?.confirmpassword?.message}</FormHelperText>

                                        </FormControl>
                                    </MDBox>
                                    <MDBox mt={2}>
                                        <MDButton type='submit' variant="gradient" color="info" fullWidth>
                                            {t('Submit')}
                                        </MDButton>
                                    </MDBox>
                                </FramerFade>
                                <FramerFade isActive={activeStep === 3} delay={0} >
                                    <Popover
                                        open={isOpenHelp}
                                        anchorEl={anchorEl}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        disableScrollLock={true}
                                        onClose={() => setIsOpenHelp(false)}
                                        PaperProps={{
                                            sx: {
                                                minWidth: 250, 
                                                maxWidth: 380, 
                                                width: '100%', 
                                            },
                                        }}
                                    >
                                        <MDTypography variant="h6" color="info" px={2} py={1} mb={-1}>
                                            {t('ForgotPasswordPage.How to Find Your Owner ID')}
                                        </MDTypography>
                                        
                                        <MDBox mx={2} px={1} mb={-1}>
                                            <MDTypography
                                                variant="caption"
                                            >
                                                {t("ForgotPasswordPage.1. Visit the ")}
                                            </MDTypography>
                                            
                                            <MDTypography
                                                component={Link}
                                                to="https://oms.darwynnfulfillment.com/ocplogin"
                                                variant="caption"
                                                color="info"
                                                fontWeight="medium"
                                                textGradient
                                                target="_blank"
                                            >
                                                {t("ForgotPasswordPage.old OCP platform")}
                                            </MDTypography>
                                        </MDBox>
                                        
                                        <MDTypography
                                            variant="caption"
                                            mx={2} 
                                            px={1}
                                        >
                                            {t("ForgotPasswordPage.2. Log in with your old credentials")}
                                        </MDTypography>
                                        
                                        <MDTypography
                                            display="block"
                                            variant="caption"
                                            mx={2} 
                                            px={1}
                                        >
                                            {t("ForgotPasswordPage.3. Open ")}
                                            <FormatListBulleted color={darkMode?'white':'info.main'} />
                                            {t("ForgotPasswordPage. SIDEBAR and go to")}
                                        </MDTypography>
                                        
                                        <MDTypography
                                            display="block"
                                            variant="caption"
                                            mx={2} 
                                            px={1}
                                            mb={1}
                                        >
                                            Data Center > Commodity Setup > Commodity Entry
                                        </MDTypography>
                                        
                                        <MDTypography
                                            display="block"
                                            variant="caption"
                                            mx={2}
                                            px={1}
                                        >
                                            {t("ForgotPasswordPage.4. Press ")}
                                            <Search color={darkMode?'white':'info.main'} />
                                            {t("ForgotPasswordPage. QUERY to locate items.")}
                                        </MDTypography>
                                        
                                        <MDTypography
                                            display="block"
                                            variant="caption"
                                            mx={2} 
                                            mb={2} 
                                            px={1}
                                        >
                                            {t("ForgotPasswordPage.Your Owner ID is in the first column (eg. S1234)")}
                                        </MDTypography>
                                        
                                        <MDBox mx={3} mb={1} >
                                            <MDButton
                                                variant="gradient"
                                                coloredShadow="success"
                                                text="standard"
                                                color="info"
                                                
                                                onClick={() => setIsOpenHelp(false)}
                                            >
                                                {t("ForgotPasswordPage.Got it!")}
                                            </MDButton>
                                        </MDBox>
                                    </Popover>
                                    <MDBox >
                        
                                        <FormControl
                                            error = {!!errors.owner}
                                            fullWidth
                                            required
                                            focused = {true}
                                        >
                                            <MDInput
                                                type="text"
                                                label={t('ForgotPasswordPage.Legacy Owner ID')}
                                                variant="standard"
                                                fullWidth
                                                required
                                                {...register("owner")}
                                                
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="Owner ID Help"
                                                                onClick={handleClickShowHelp}
                                                                edge="end"
                                                            >
                                                                <Help color={darkMode?'white':'info.main'} />
                                                            </IconButton>
                                                        </InputAdornment>
                
                                                }}
                                            />
                                            <FormHelperText sx={{fontWeight:'medium'}}>{errors?.owner?.message}</FormHelperText>
                                        </FormControl>
                                    </MDBox>
                                    <MDBox >
                                        <FormControl
                                          error = {!!errors.user}
                                          fullWidth
                                          required
                                          focused = {true}
                                        >
                                            <MDInput
                                              type="text"
                                              label={t('ForgotPasswordPage.Legacy Username')}
                                              variant="standard"
                                              fullWidth
                                              required
                                              {...register("user")}
                                              
                                              InputProps={{
                                                endAdornment:
                                                    <InputAdornment position="end">
                                                        <ClickAwayListener onClickAway={() => setIsOpenInfo(false)} >
                                                            <Tooltip 
                                                                title={t('ForgotPasswordPage.Known as User ID on the old OCP platform')}
                                                                open={isOpenInfo}
                                                                onClickAway
                                                            >
                                                                <IconButton
                                                                    aria-label="Legacy Username Info"
                                                                    edge="end"
                                                                    onClick={() => setIsOpenInfo(!isOpenInfo)}
                                                                >
                                                                    <Info color={darkMode?'white':'info.main'} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </ClickAwayListener>
                                                    </InputAdornment>
                
                                               }}
                                            />
                                            <FormHelperText sx={{fontWeight:'medium'}}>{errors?.user?.message}</FormHelperText>
                                        </FormControl>
                                    </MDBox>
                                    <MDBox mb={1}>
                                        <FormControl
                                            error = {!!errors.userpassword}
                                            fullWidth
                                            required
                                            focused = {true}
                                        >
                                            <MDInput
                                                type={showPassword?'text':'password'}
                                                label={t('ForgotPasswordPage.New Password')}
                                                variant="standard"
                                                fullWidth
                                                required
                                                {...register("userpassword")}
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={handleClickShowPassword}
                                                                edge="end"
                                                            >
                                                                {showPassword ? <VisibilityOff color={darkMode?'white':'info.main'} /> : <Visibility color={darkMode?'white':'info.main'} />}
                                                            </IconButton>
                                                        </InputAdornment>
                
                                                }}
                                            />
                                            <FormHelperText sx={{fontWeight:'medium'}}>{errors?.userpassword?.message}</FormHelperText>
                                            <MDTypography variant={'caption'} mt={1} >{t('ForgotPasswordPage.Password must have')}</MDTypography>
                                            <MDTypography variant={'caption'} pl={1} > {t('ForgotPasswordPage.at least 6 characters')}</MDTypography>
                                            <MDTypography variant={'caption'} pl={1} > {t('ForgotPasswordPage.at least one uppercase')}</MDTypography>
                                            <MDTypography variant={'caption'} pl={1} > {t('ForgotPasswordPage.at least one lowercase')}</MDTypography>
                                            <MDTypography variant={'caption'} pl={1} > {t('ForgotPasswordPage.at least one number')}</MDTypography>
                                        </FormControl>
                                    </MDBox>
                                    <MDBox mb={1}>
                                        <FormControl
                                            error = {!!errors.userconfirmpassword}
                                            fullWidth
                                            required
                                            focused = {true}
                                        >
                                            <MDInput
                                                type={showPasswordConfirmation?'text':'password'}
                                                label= {t('ForgotPasswordPage.New Password Confirmation')}
                                                variant="standard"
                                                fullWidth
                                                required
                                                {...register("userconfirmpassword")}
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={handleClickShowPasswordConfirmation}
                                                                edge="end"
                                                            >
                                                                {showPasswordConfirmation ? <VisibilityOff color={darkMode?'white':'info.main'} /> : <Visibility color={darkMode?'white':'info.main'} />}
                                                            </IconButton>
                                                        </InputAdornment>
                
                                                }}
                                            />
                                            <FormHelperText sx={{fontWeight:'medium'}}>{errors?.userconfirmpassword?.message}</FormHelperText>
                                        </FormControl>
                                    </MDBox>
                                    <MDBox sx={{position:'relative'}}>
                                        <FormControl
                                            error = {!!errors.code}
                                            fullWidth
                                            required
                                        >
                                            <MDInput
                                                label={t('Verification')}
                                                {...register("code")}
                                                variant='standard'
                                                fullWidth
                                                required
                                                error={!!errors.code}
                                                InputProps={{
                                                    endAdornment:  <InputAdornment position="end" >
                                                        <img
                                                            src={img}
                                                            alt={'verification code'}
                                                            style={style.img}
                                                            onClick={async () => await dispatch(getVerificationCode())}
                                                            loading="lazy"
                                                        />
                                                    </InputAdornment>
                                                }}
                                            />
                                            <FormHelperText sx={{fontWeight:'medium'}}>{errors?.code?.message}</FormHelperText>
                                        </FormControl>
                                    </MDBox>
                                    <MDBox mt={2}>
                                        <MDButton type='submit' variant="gradient" color="info" fullWidth >
                                            {t('Submit')}
                                        </MDButton>
                                    </MDBox>
                                </FramerFade>
                            </MDBox>
                        </MDBox>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setActiveStep(0)
                        setEmailMode(true)
                        clearErrors()
                        setValue('email', '')
                        handleClose()
                    }}
                    >{t('Cancel')}</Button>
                    {(activeStep === 3 || activeStep === 2)&& <Button onClick={() => {
                        setActiveStep(0)
                        setEmailMode(true)
                        clearErrors()
                        setValue('email', '')
                        reset()
                        setShowPassword(false)
                        setShowPasswordConfirmation(false)
                        setCode(Array(6).fill(''));
                    }}
                    >{t('Go Back')}</Button>}
                    {(activeStep !== 3 &&  activeStep !== 2) && <Button onClick={handleNext} disabled={activeStep === 3}>{t('Next')}</Button>}
                </DialogActions>
            </Dialog>
        </React.Fragment>)
}